import { useQuery } from '@tanstack/react-query';

import type { MakeupBooking } from '~entities/makeup/api/book-makeup';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const getMakeupsByStudentAPI = async (params: {
  studentId: string;
  sessionId?: string;
}) => {
  const response = await baseAPI.get<Array<MakeupBooking>>(
    `/makeup/student/${params.studentId}`,
    {
      params: params.sessionId ? { sessionId: params.sessionId } : undefined,
    },
  );
  return response.data;
};

export const useGetMakeupsByStudent = (
  params: { studentId: string; sessionId?: string },
  enabled = true,
) => {
  return useQuery({
    queryKey: [
      KEYS.MAKEUP_BY_STUDENT,
      params.studentId,
      params.sessionId ?? 'all',
    ],
    queryFn: () => getMakeupsByStudentAPI(params),
    enabled: enabled && !!params.studentId,
  });
};
